<template>
  <div>
    <v-row class="mt-15"></v-row>
    <v-footer fixed padless inset class="footer-wrapper mb-0 py-5"       hide-on-scroll
>
    <v-row justify="start" align="center">
        <v-col class="text-center px-8 py-1 footer-section ">
            {{ orgName }} - نظام شؤون العاملين بواسطة النمو التقني &copy;{{ new Date().getFullYear() }}
        </v-col>
    </v-row>
  </v-footer>
  </div>

</template>

<script>
export default {
  computed: {
    orgName() {
      return this.$store.getters["organization/displayName"];
    },
  },
};
</script>
